import { useParams } from 'react-router-dom';
import CTA from '../components/CTA';
import { DetailGallery } from '../components/gallery/DetailGallery';
import { DetailBreadcrumb, DetailNavigation } from '../components/details/DetailNavigation';
import { ProjectInfo } from '../components/details/ProjectInfo';
import { usePortfolioDetail } from '../hooks/usePortfolioDetail';
import { useSeo } from '../hooks/useSeo';

export default function ProjectDetailPage() {
  const { slug } = useParams();
  const { item: project, images, ...navigation } = usePortfolioDetail('project', slug);
  useSeo({
    title: project?.title || 'Proje',
    description: project && `${project.title} - ${project.location} - ${project.year} - ${project.areaM2} m² - ${project.material} - ${project.form}. Membratek tarafindan tamamlanan asma germe / membran yapi projesi.`,
    path: project ? `/projeler/${project.slug}` : '/projeler',
    image: project?.image,
  });
  if (!project) return null;
  return (
    <main>
      <DetailBreadcrumb kind="project" basePath="/projeler" label="Tamamlanmis Projeler" />
      <section className="py-16 lg:py-20 px-6 lg:px-10">
        <div className="max-w-[1300px] mx-auto grid lg:grid-cols-2 gap-10 lg:gap-14">
          <ProjectInfo project={project} />
          <DetailGallery key={project.slug} kind="project" title={project.title} images={images} />
        </div>
      </section>
      <DetailNavigation kind="project" label="Proje" {...navigation} />
      <CTA />
    </main>
  );
}